module.exports = __webpack_public_path__ + "img/yuyuejiance.cb68eb33.jpg";